import "./styles.scss"

export const RadioButton = ({
  onChange,
  value,
  checked,
  name,
  text,
  className,
  disabled,
  id,
  variant,
  classPrymary = ""
}) => {
  return (
    <div className={classPrymary}>
      <input
        type="radio"
        value={value}
        checked={checked}
        name={name}
        onChange={onChange}
        id={id || "radio-button"}
        className={`radio-button ${className ? className : ""}`}
        disabled={disabled}
      />
      {text && (
        <label disabled={disabled} htmlFor={id || "radio-button"}>
          {text}
        </label>
      )}
    </div>
  )
}

export const RadioGroup = ({ children }) => {
  return <fieldset className="fieldset">{children}</fieldset>
}